module.exports = __webpack_public_path__ + "img/prize1.502fce7.png";